// extracted by mini-css-extract-plugin
export default {"category":"ingredients-category_category__i35an","category__list":"ingredients-category_category__list__HwbqZ"};